
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire34b5"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire34b5"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("3NQOU", function(module, exports) {
$parcel$export(module.exports, "init", function () { return $b6785f1d81c92020$export$2cd8252107eb640b; });

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $yhhhl = parcelRequire("yhhhl");

var $konOj = parcelRequire("konOj");

var $fuLgT = parcelRequire("fuLgT");

var $eQyIx = parcelRequire("eQyIx");

var $g0QpW = parcelRequire("g0QpW");

var $gLm0b = parcelRequire("gLm0b");

var $6r14Z = parcelRequire("6r14Z");

var $hgaI1 = parcelRequire("hgaI1");

var $7mHQv = parcelRequire("7mHQv");

var $hp3ar = parcelRequire("hp3ar");

var $6gQvZ = parcelRequire("6gQvZ");

var $idVA4 = parcelRequire("idVA4");

var $hu7gH = parcelRequire("hu7gH");
window.BUILD_KEY = "p-a406c4400d";
window.featureGateBootstrapValues = window.featureGateBootstrapValues || {
    identifiers: {
        analyticsAnonymousId: (0, $fuLgT.default)()
    }
};
const $b6785f1d81c92020$var$SUPPORTED_LOCALES = [
    {
        hrefLang: "ja",
        langRoute: "ja"
    },
    {
        hrefLang: "fr",
        langRoute: "fr"
    },
    {
        hrefLang: "de",
        langRoute: "de"
    },
    {
        hrefLang: "es",
        langRoute: "es"
    },
    {
        hrefLang: "pt-BR",
        langRoute: "br"
    },
    {
        hrefLang: "zh-Hans",
        langRoute: "zh"
    },
    {
        hrefLang: "ko",
        langRoute: "ko"
    },
    {
        hrefLang: "ru",
        langRoute: "ru"
    },
    {
        hrefLang: "pl",
        langRoute: "pl"
    },
    {
        hrefLang: "it",
        langRoute: "it"
    },
    {
        hrefLang: "nl",
        langRoute: "nl"
    }
];
const $b6785f1d81c92020$export$2cd8252107eb640b = (Component)=>{
    const isStatic = typeof window !== "undefined" && window.IS_STATIC;
    const analyticsWebClient = (0, $g0QpW.getAnalyticsWebClient)();
    const { locale: locale, path: path } = (0, $hu7gH.parseRoute)(window.location);
    // Get location data for experiments and feature gates from server-provided data
    let locationData;
    // Use server-provided data (no client-side API calls)
    if (typeof window !== "undefined") locationData = {
        countryIsoCode: window.countryCode || "",
        regionIsoCode: window.regionIsoCode || ""
    };
    // In Uniform Playground (preview authoring environment), skip OneTrust check
    // and assume performance tracking is enabled — mirrors OneTrustProvider behavior.
    // Cookies are unavailable in the cross-origin iframe context, so the normal
    // cookie-based check always returns false for CPRA users (e.g. California).
    const isPerfOnetrustEnabled = window.isUniformPlayground || (0, $gLm0b.isPerformanceOnetrustEnabled)(typeof window !== "undefined" ? window.optanonConsentCookie : (0, $gLm0b.extractOptanonConsentCookie)(document.cookie), locationData);
    isPerfOnetrustEnabled && (0, $eQyIx.initUFO)(analyticsWebClient, path);
    const parsedClientCookies = document.cookie ? (0, $yhhhl.parse)(document.cookie) : {};
    const userAgent = typeof window !== "undefined" ? window.navigator.userAgent : "";
    const { finalExperimentOverrides: finalExperimentOverrides, finalFeatureGateOverrides: finalFeatureGateOverrides } = (0, $idVA4.processExperimentAndFeatureGateOverrides)(parsedClientCookies, userAgent, isPerfOnetrustEnabled);
    // Below is for debugging edge - will be removed
    window.ssrAnonId = window.featureGateBootstrapValues.identifiers.analyticsAnonymousId;
    // We can't feature gate below code as this is done before initialization so just overriding for the path we are testing
    if ((0, $hp3ar.isEdgeCachingPath)(window.location.pathname)) {
        // Override for Edge Caching
        (0, $hp3ar.overrideAjsAnonIdFromCookie)();
        (0, $hp3ar.overrideCustomAttributes)();
    }
    (0, $hgaI1.initializeFeatureGatesClient)(window.featureGateBootstrapValues, {
        overrideValues: {
            experimentOverrides: finalExperimentOverrides,
            featureGateOverrides: finalFeatureGateOverrides
        },
        // if performance cookies are disabled, we will skip exposures
        localMode: !isPerfOnetrustEnabled
    }).then(()=>{
        const canonicalBaseUrl = (0, $6r14Z.getCanonicalBaseUrl)(window.location.hostname, path);
        const pathForCanonical = path ? (0, $6r14Z.canonicalPathForHref)(canonicalBaseUrl, path) : undefined;
        const route = pathForCanonical === undefined ? "" : pathForCanonical === "" ? "" : `/${pathForCanonical}`;
        const page = /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $6gQvZ.SentryIntlProvider), {
            locale: locale,
            messages: window.SSR_languagePack,
            cookies: document.cookie,
            children: [
                isStatic && /*#__PURE__*/ (0, $7VQPk.jsx)("link", {
                    rel: "canonical",
                    href: `${canonicalBaseUrl}${route}`
                }),
                isStatic && /*#__PURE__*/ (0, $7VQPk.jsx)("link", {
                    rel: "alternate",
                    href: `${canonicalBaseUrl}${route}`,
                    hrefLang: "x-default"
                }),
                isStatic && $b6785f1d81c92020$var$SUPPORTED_LOCALES.map(({ hrefLang: hrefLang, langRoute: langRoute })=>/*#__PURE__*/ (0, $7VQPk.jsx)("link", {
                        rel: "alternate",
                        href: `${canonicalBaseUrl}/${langRoute}${route}`,
                        hrefLang: hrefLang
                    }, hrefLang)),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7mHQv.PageWrapper), {
                    analyticsWebClient: analyticsWebClient,
                    location: window.location,
                    pricing: window.prices,
                    availableProducts: window.availableProducts,
                    userProfile: window.userProfile,
                    userProfileStatus: window.userProfileStatus,
                    userContext: window.userContext,
                    userContextStatus: window.userContextStatus,
                    loggedOutContext: window.loggedOutContext,
                    loggedOutContextStatus: window.loggedOutContextStatus,
                    loggedInContext: window.loggedInContext,
                    loggedInContextStatus: window.loggedInContextStatus,
                    countryCode: window.countryCode,
                    templates: window.templates,
                    partnerTemplates: window.partnerTemplates,
                    collections: window.collections,
                    categories: window.categories,
                    composition: window._uniformPreloadedComposition,
                    compositionRegenerationMetadata: window._uniformRegenerationMetadata,
                    isUniformPlayground: window.isUniformPlayground,
                    isAllowPostMessage: window.isAllowPostMessage,
                    teamType: window.teamType,
                    keyword: window.keyword,
                    referrer: window.referrer,
                    mlTemplateIds: window.mlTemplateIds,
                    track: window.track,
                    anchor: window.anchor,
                    subAnchor: window.subAnchor,
                    auxiaResponse: window.auxiaResponse,
                    PageComponent: Component,
                    transactionAccounts: window.transactionAccounts,
                    userAgent: userAgent,
                    clusterTag: window.clusterTag
                })
            ]
        });
        if (isStatic) {
            // @ts-ignore
            const root = (0, $konOj.createRoot)(document.getElementById("wac"));
            root.render(page);
        } else (0, $konOj.hydrateRoot)(// @ts-ignore
        document.getElementById("wac-root"), page, {
            onRecoverableError: (error, errorInfo)=>{
                document.getElementById("wac-root")?.setAttribute("hydration-error", "true");
            }
        });
    });
};

});

parcelRegister("02cSL", function(module, exports) {
$parcel$export(module.exports, "JiraSoftwareFreePage", function () { return $a6d720ca803f2dba$export$a1727845ccb60c5c; });

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1hDfS");
var $2ymPl = parcelRequire("2ymPl");

var $7VwhR = parcelRequire("7VwhR");

var $doAVE = parcelRequire("doAVE");

var $kooLp = parcelRequire("kooLp");

var $ea4mV = parcelRequire("ea4mV");

var $1ka2O = parcelRequire("1ka2O");
const $a6d720ca803f2dba$export$a1727845ccb60c5c = ()=>{
    const isLoggedIn = (0, $doAVE.useLoggedIn)();
    const jiraPlusExperiment = (0, $ea4mV.useExperiment)((0, $ea4mV.experiments).twcg1444JiraPlusOptIn);
    const jiraPlusExperimentPaid = (0, $ea4mV.useExperiment)((0, $ea4mV.experiments).twcg1444JiraPlusOptInPaid);
    const signupPath = (0, $kooLp.useLocalizedHref)("/try/cloud/signup");
    const location = (0, $1ka2O.useLocation)();
    const isPaidExperience = (0, $7VwhR.hasJiraPlusPaidParam)(location);
    const experiment = isPaidExperience ? jiraPlusExperimentPaid : jiraPlusExperiment;
    if (isLoggedIn && experiment.type === (0, $ea4mV.EnrollmentType).ENROLLED) {
        experiment.fireExposure();
        if (experiment.value) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2ymPl.JiraPlus), {});
    }
    // ATLAS-55799 - JSW Find Team
    const queryParameters = new URLSearchParams(location.search);
    const templateId = queryParameters.get("templateId") ?? "";
    const jiraProductTourSignupType = queryParameters.get("jiraProductTourSignupType") ?? "";
    const signupParameters = new URLSearchParams({
        bundle: "jira-software",
        edition: "free",
        skipBundles: "true"
    });
    if (templateId) signupParameters.append("templateId", templateId);
    if (jiraProductTourSignupType) signupParameters.append("jiraProductTourSignupType", jiraProductTourSignupType);
    if (typeof window !== "undefined") window.location.assign(`${signupPath}?${signupParameters}`);
    return null;
};

});
parcelRegister("1hDfS", function(module, exports) {
$parcel$export(module.exports, "JiraPlus", function () { return (parcelRequire("2ymPl")).JiraPlus; });
parcelRequire("2ymPl");

});
parcelRegister("2ymPl", function(module, exports) {
$parcel$export(module.exports, "JiraPlus", function () { return $73cea66d8ab3b938$export$cd61a514420a0945; });
/* jira-plus.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $iVyKn = parcelRequire("iVyKn");

var $eY3N6 = parcelRequire("eY3N6");

var $46Ma8 = parcelRequire("46Ma8");

var $55Jan = parcelRequire("55Jan");

var $9Cyyz = parcelRequire("9Cyyz");

var $a9Umc = parcelRequire("a9Umc");

var $63bv7 = parcelRequire("63bv7");

var $kvjl7 = parcelRequire("kvjl7");

var $k9ZIM = parcelRequire("k9ZIM");

var $2fk4i = parcelRequire("2fk4i");

var $kooLp = parcelRequire("kooLp");

var $1ka2O = parcelRequire("1ka2O");

var $k18Zl = parcelRequire("k18Zl");
const $73cea66d8ab3b938$export$cd61a514420a0945 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const analyticsClient = (0, $k9ZIM.useAnalyticsClient)();
    (0, $1oC0p.useEffect)(()=>{
        if (!analyticsClient) return; // be sure analyticsClient is available before firing event
        createAnalyticsEvent({
            action: "viewed",
            actionSubject: "component",
            actionSubjectId: "jiraPlusModal",
            attributes: {
                source: "jiraPlusModal"
            }
        }).fire();
    }, [
        analyticsClient,
        createAnalyticsEvent
    ]);
    const location = (0, $1ka2O.useLocation)();
    const searchParams = new URLSearchParams(location.search);
    const editionIntent = searchParams.get("editionIntent");
    const jiraSignupHref = (0, $kooLp.useLocalizedHref)(`/try/cloud/signup${editionIntent ? `?editionIntent=${editionIntent}` : ""}`);
    const twcSignupHref = (0, $kooLp.useLocalizedHref)(`/try/cloud/signup?bundle=teamwork-collection&edition=premium&touchpoint=jira-plus`);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kvjl7.JiraBackground), {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $k18Zl.Modal), {
            version: (0, $k18Zl.LayoutVersion).V3,
            children: /*#__PURE__*/ (0, $7VQPk.jsxs)("section", {
                className: (0, $2jatx.default)([
                    "_ect4b1j9 _181n1txw _b8yqiafe _15y11ccs _14b51osq"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("article", {
                        className: (0, $2jatx.default)([
                            "_4cvrv2br _1e0c1txw _16jlkb7n _1o9zkb7n _i0dlf1ug _2lx21bp4 _ca0qviql _u5f3viql _n3tdviql _19bvviql",
                            "_bfhku67f _syaz1kw7 _15vtoqnp"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_4cvr1h6o _1e0c1txw _zulp1j6v _6rth1j6v"
                                ]),
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $63bv7.JiraLogo), {
                                    size: "medium",
                                    appearance: "brand",
                                    shouldUseNewLogoDesign: true
                                })
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("h1", {
                                className: (0, $2jatx.default)([
                                    "_vwz41j7w"
                                ]),
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                    id: "jiraPlus.jiraHeading",
                                    defaultMessage: "Get started with Jira only"
                                })
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                className: (0, $2jatx.default)([
                                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                                ]),
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                    id: "jiraPlus.jiraDescription",
                                    defaultMessage: "Get AI-powered project management for all teams."
                                })
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsxs)("ul", {
                                className: (0, $2jatx.default)([
                                    "_2mzuglyw _6rth1k8s _1pfhidpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsxs)("li", {
                                        className: (0, $2jatx.default)([
                                            "_4cvrv2br _1e0c1txw _zulpoqnp _1pfh1k8s _ny56133k",
                                            "_1nj1doyu"
                                        ]),
                                        children: [
                                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($a9Umc))), {
                                                label: ""
                                            }),
                                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                                id: "jiraPlus.planAndTrack",
                                                defaultMessage: "Plan and track your work"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsxs)("li", {
                                        className: (0, $2jatx.default)([
                                            "_4cvrv2br _1e0c1txw _zulpoqnp _1pfh1k8s _ny56133k",
                                            "_1nj1doyu"
                                        ]),
                                        children: [
                                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($55Jan))), {
                                                label: ""
                                            }),
                                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                                id: "jiraPlus.aiPoweredProjectsAndInsights",
                                                defaultMessage: "Get AI-powered projects and insights"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsxs)("li", {
                                        className: (0, $2jatx.default)([
                                            "_4cvrv2br _1e0c1txw _zulpoqnp _1pfh1k8s _ny56133k",
                                            "_1nj1doyu"
                                        ]),
                                        children: [
                                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9Cyyz))), {
                                                label: ""
                                            }),
                                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                                id: "jiraPlus.automateTasks",
                                                defaultMessage: "Automate tasks to keep work moving smoothly"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Button), {
                                href: jiraSignupHref,
                                onClick: (e)=>{
                                    e.preventDefault(); // wait for analytics event to fire before navigating
                                    createAnalyticsEvent({
                                        action: "clicked",
                                        actionSubject: "button",
                                        actionSubjectId: "getJiraOnly",
                                        attributes: {
                                            source: "jiraPlusModal"
                                        }
                                    }).fire();
                                    window.location.assign(jiraSignupHref);
                                },
                                className: (0, $2jatx.default)([
                                    "_ect41kw7 _1wyboxwj _k48pbfng _1pfh1wug _p12f1wug _1rjc1kwk _1bsb1osq",
                                    "_bfhk1j28 _19it1jxq _syaz1kw7 _irr31fkg"
                                ]),
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                    id: "jiraPlus.jiraButtonText",
                                    defaultMessage: "Get Jira only"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0cglyw _1jb36tgj _kxohy1ik _181n1ule _14b58pqr"
                        ])
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("article", {
                        className: (0, $2jatx.default)([
                            "_4cvrv2br _1e0c1txw _16jlkb7n _1o9zkb7n _i0dlf1ug _2lx21bp4 _ca0qviql _u5f3viql _n3tdviql _19bvviql",
                            "_bfhk6tgj _syazu67f _1wfqoqnp"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                className: (0, $2jatx.default)([
                                    "_4cvr1h6o _1e0c1txw _zulp1j6v _6rth1j6v",
                                    "_h47hu67f"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $63bv7.JiraLogo), {
                                        size: "medium",
                                        appearance: "brand",
                                        shouldUseNewLogoDesign: true
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($46Ma8))), {
                                        label: ""
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                        className: (0, $2jatx.default)([
                                            "_1e0c1txw _zulp1kwk"
                                        ]),
                                        children: [
                                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $63bv7.ConfluenceIcon), {
                                                appearance: "brand",
                                                shouldUseNewLogoDesign: true
                                            }),
                                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $63bv7.LoomIcon), {
                                                appearance: "brand",
                                                shouldUseNewLogoDesign: true
                                            }),
                                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $63bv7.RovoIcon), {
                                                appearance: "brand",
                                                shouldUseNewLogoDesign: true
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("h1", {
                                className: (0, $2jatx.default)([
                                    "_vwz41j7w"
                                ]),
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                    id: "jiraPlus.twcHeading",
                                    defaultMessage: "Or work <em>3x faster</em> with teamwork apps",
                                    values: {
                                        em: $73cea66d8ab3b938$var$headingEmphasis
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                className: (0, $2jatx.default)([
                                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                                ]),
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                    id: "jiraPlus.twcDescription",
                                    defaultMessage: "Boost productivity by adding apps that supercharge teamwork."
                                })
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                className: (0, $2jatx.default)([
                                    "_k48pbfng _6rthidpf _1pfh1k8s"
                                ]),
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                    id: "jiraPlus.twcListIntro",
                                    defaultMessage: "Get everything from Jira, plus:"
                                })
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsxs)("ul", {
                                className: (0, $2jatx.default)([
                                    "_2mzuglyw _6rth1k8s _1pfhidpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsxs)("li", {
                                        className: (0, $2jatx.default)([
                                            "_4cvrv2br _1e0c1txw _zulpoqnp _1pfh1k8s _ny56133k"
                                        ]),
                                        children: [
                                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $63bv7.ConfluenceIcon), {
                                                appearance: "brand",
                                                shouldUseNewLogoDesign: true,
                                                size: "xxsmall"
                                            }),
                                            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                                    id: "jiraPlus.bundleJiraWithConfluence",
                                                    defaultMessage: "Bundle Jira with <em>Confluence</em>, so all your work stays in one place",
                                                    values: {
                                                        em: $73cea66d8ab3b938$var$listEmphasis
                                                    }
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsxs)("li", {
                                        className: (0, $2jatx.default)([
                                            "_4cvrv2br _1e0c1txw _zulpoqnp _1pfh1k8s _ny56133k"
                                        ]),
                                        children: [
                                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $63bv7.LoomIcon), {
                                                appearance: "brand",
                                                shouldUseNewLogoDesign: true,
                                                size: "xxsmall"
                                            }),
                                            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                                    id: "jiraPlus.saveTimeWithLoom",
                                                    defaultMessage: "Save time with <em>Loom\u2019s</em> AI-generated meeting notes",
                                                    values: {
                                                        em: $73cea66d8ab3b938$var$listEmphasis
                                                    }
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsxs)("li", {
                                        className: (0, $2jatx.default)([
                                            "_4cvrv2br _1e0c1txw _zulpoqnp _1pfh1k8s _ny56133k"
                                        ]),
                                        children: [
                                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $63bv7.RovoIcon), {
                                                appearance: "brand",
                                                shouldUseNewLogoDesign: true,
                                                size: "xxsmall"
                                            }),
                                            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                                    id: "jiraPlus.createAndSearchWithRovo",
                                                    defaultMessage: "Easily create and search for knowledge with <em>Rovo</em>",
                                                    values: {
                                                        em: $73cea66d8ab3b938$var$listEmphasis
                                                    }
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Button), {
                                href: twcSignupHref,
                                onClick: (e)=>{
                                    e.preventDefault(); // wait for analytics event to fire before navigating
                                    createAnalyticsEvent({
                                        action: "clicked",
                                        actionSubject: "button",
                                        actionSubjectId: "getTwc",
                                        attributes: {
                                            source: "jiraPlusModal"
                                        }
                                    }).fire();
                                    window.location.assign(twcSignupHref);
                                },
                                className: (0, $2jatx.default)([
                                    "_ect41kw7 _1wyboxwj _k48pbfng _1pfh1wug _p12f1wug _1rjc1kwk _1bsb1osq",
                                    "_irr31q0g"
                                ]),
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                    id: "jiraPlus.twcButtonText",
                                    defaultMessage: "Try them for free"
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
};
const $73cea66d8ab3b938$var$headingEmphasis = (children)=>/*#__PURE__*/ (0, $7VQPk.jsx)("span", {
        className: (0, $2jatx.default)([
            "_kqswh2mm _o5721q9c _1pbyidpf _1kt9b3bt _1cs8stnw _1rus1yy8 _1rhx1o5r _144l133k _1mp41pfy _kfgtkh0n _7dwzxjsu _1g0v1mrw"
        ]),
        children: children
    });
const $73cea66d8ab3b938$var$listEmphasis = (children)=>/*#__PURE__*/ (0, $7VQPk.jsx)("span", {
        className: (0, $2jatx.default)([
            "_k48p1fw0"
        ]),
        children: children
    });
const $73cea66d8ab3b938$var$COLORS = {
    // eslint-disable-next-line local/ensure-wac-token-usage
    B700: "#1868DB",
    // eslint-disable-next-line local/ensure-wac-token-usage
    B800: "#1558BC",
    // eslint-disable-next-line local/ensure-wac-token-usage
    B900: "#123263",
    // eslint-disable-next-line local/ensure-wac-token-usage
    N300: "#DDDEE1",
    // eslint-disable-next-line local/ensure-wac-token-usage
    N300A: "#0B120E24",
    // eslint-disable-next-line local/ensure-wac-token-usage
    P500: "#BF63F3"
};
const $73cea66d8ab3b938$var$buttonCss = null;
const $73cea66d8ab3b938$var$choiceCss = null;
const $73cea66d8ab3b938$var$descriptionCss = null;
const $73cea66d8ab3b938$var$headingCss = null;
const $73cea66d8ab3b938$var$headingEmphasisCss = null;
const $73cea66d8ab3b938$var$iconsCss = null;
const $73cea66d8ab3b938$var$jiraButtonCss = null;
const $73cea66d8ab3b938$var$jiraChoiceCss = null;
const $73cea66d8ab3b938$var$listEmphasisCss = null;
const $73cea66d8ab3b938$var$jiraListItemCss = null;
const $73cea66d8ab3b938$var$listCss = null;
const $73cea66d8ab3b938$var$listIntroCss = null;
const $73cea66d8ab3b938$var$listItemCss = null;
const $73cea66d8ab3b938$var$logosCss = null;
const $73cea66d8ab3b938$var$modalContentCss = null;
const $73cea66d8ab3b938$var$separatorCss = null;
const $73cea66d8ab3b938$var$twcButtonCss = null;
const $73cea66d8ab3b938$var$twcChoiceCss = null;
const $73cea66d8ab3b938$var$twcLogosCss = null;

});
parcelRegister("46Ma8", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e570c2c471e9f2c44e5e57e4d5245eb9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2fdd15086956a812$var$_react = $2fdd15086956a812$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $2fdd15086956a812$var$_baseNew = $2fdd15086956a812$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $2fdd15086956a812$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Add".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for creating and adding an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2fdd15086956a812$var$AddIcon = (props)=>/*#__PURE__*/ $2fdd15086956a812$var$_react.default.createElement($2fdd15086956a812$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M7.25 8.75V15h1.5V8.75H15v-1.5H8.75V1h-1.5v6.25H1v1.5z" clip-rule="evenodd"/>`
    }, props));
$2fdd15086956a812$var$AddIcon.displayName = 'AddIcon';
var $2fdd15086956a812$var$_default = module.exports.default = $2fdd15086956a812$var$AddIcon;

});

parcelRegister("55Jan", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b8054c1d672105cf334f7f37a83f0cf2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3b5074773e8f1916$var$_react = $3b5074773e8f1916$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $3b5074773e8f1916$var$_baseNew = $3b5074773e8f1916$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $3b5074773e8f1916$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AtlassianIntelligence".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for Atlassian Intelligence products or experiences.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3b5074773e8f1916$var$AtlassianIntelligenceIcon = (props)=>/*#__PURE__*/ $3b5074773e8f1916$var$_react.default.createElement($3b5074773e8f1916$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M7.25 4V1h1.5v3zM5.47 6.53l-4-4 1.06-1.06 4 4zm4-1.06 4-4 1.06 1.06-4 4zM1 7.25h3v1.5H1zm11 0h3v1.5h-3zM1.47 13.47l4-4 1.06 1.06-4 4zm12 1.06-4-4 1.06-1.06 4 4zM7.25 15v-3h1.5v3z" clip-rule="evenodd"/>`
    }, props));
$3b5074773e8f1916$var$AtlassianIntelligenceIcon.displayName = 'AtlassianIntelligenceIcon';
var $3b5074773e8f1916$var$_default = module.exports.default = $3b5074773e8f1916$var$AtlassianIntelligenceIcon;

});

parcelRegister("9Cyyz", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2251b011785916069b749fddb2c5cd02>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $701277dc6e7898a3$var$_react = $701277dc6e7898a3$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $701277dc6e7898a3$var$_baseNew = $701277dc6e7898a3$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $701277dc6e7898a3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Automation".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved to represent an Automation.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $701277dc6e7898a3$var$AutomationIcon = (props)=>/*#__PURE__*/ $701277dc6e7898a3$var$_react.default.createElement($701277dc6e7898a3$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M10.377.102a.75.75 0 0 1 .346.847L8.985 7.25h4.265a.75.75 0 0 1 .53 1.28l-7.25 7.25a.75.75 0 0 1-1.253-.73l1.738-6.3H2.75a.75.75 0 0 1-.53-1.28L9.47.22a.75.75 0 0 1 .907-.118M7.43 7.25l1.093-3.96L4.56 7.25zm1.142 1.5-1.093 3.96 3.961-3.96z" clip-rule="evenodd"/>`
    }, props));
$701277dc6e7898a3$var$AutomationIcon.displayName = 'AutomationIcon';
var $701277dc6e7898a3$var$_default = module.exports.default = $701277dc6e7898a3$var$AutomationIcon;

});




parcelRegister("4ZpaI", function(module, exports) {
$parcel$export(module.exports, "cx", function () { return $3a20628da031bb87$export$a274e22fb40f762e; });
/* index.tsx generated by @compiled/babel-plugin v0.38.1 */ parcelRequire("1oC0p");


var $6GQYv = parcelRequire("6GQYv");
var $3a20628da031bb87$var$strictApi = (0, $6GQYv.createStrictAPI)();
var $3a20628da031bb87$export$dbf350e5966cf602 = $3a20628da031bb87$var$strictApi.css;
var $3a20628da031bb87$export$eb1ecd84a24ee424 = $3a20628da031bb87$var$strictApi.cssMap;
$3a20628da031bb87$var$strictApi.cssMap;
var $3a20628da031bb87$export$a274e22fb40f762e = $3a20628da031bb87$var$strictApi.cx;
var $3a20628da031bb87$var$XCSSProp = $3a20628da031bb87$var$strictApi.XCSSProp; // This is to mitigate local TS error TS2315: Type 'StrictXCSSProp' is not generic.
 // Currently for some reason tsc is generating malformed .d.ts in local dev environment, below change fixes it
 /**
 * ## StrictXCSSProp
 *
 * Declare styles your component takes with all other styles marked as violations
 * by the TypeScript compiler. There are two primary use cases for xcss prop:
 *
 * - safe style overrides
 * - inverting style declarations
 *
 * Interverting style declarations is interesting for platform teams as
 * it means apps only pay for styles they use as they're now the ones who declare
 * the styles!
 *
 * The {@link StrictXCSSProp} type has generics two of which must be defined — use to explicitly
 * set what you want to maintain as API. Use {@link XCSSAllProperties} and {@link XCSSAllPseudos}
 * to enable all properties and pseudos.
 *
 * The third generic is used to declare what properties and pseudos should be required.
 *
 * ```tsx
 * interface MyComponentProps {
 *   // Color is accepted, all other properties / pseudos are considered violations.
 *   xcss?: StrictXCSSProp<'color', never>;
 *
 *   // Only background color and hover pseudo are accepted.
 *   xcss?: StrictXCSSProp<'backgroundColor', '&:hover'>;
 *
 *   // All properties are accepted, all pseudos are considered violations.
 *   xcss?: StrictXCSSProp<XCSSAllProperties, never>;
 *
 *   // All properties are accepted, only the hover pseudo is accepted.
 *   xcss?: StrictXCSSProp<XCSSAllProperties, '&:hover'>;
 *
 *   // The xcss prop is required as well as the color property. No pseudos are required.
 *   xcss: StrictXCSSProp<
 *     XCSSAllProperties,
 *     '&:hover',
 *     { requiredProperties: 'color', requiredPseudos: never }
 *   >;
 * }
 *
 * function MyComponent({ xcss }: MyComponentProps) {
 *   return <div css={{ color: 'var(--ds-text-danger)' }} className={xcss} />
 * }
 * ```
 *
 * The xcss prop works with static inline objects and the [cssMap](https://compiledcssinjs.com/docs/api-cssmap) API.
 *
 * ```jsx
 * // Declared as an inline object
 * <Component xcss={{ color: 'var(--ds-text)' }} />
 *
 * // Declared with the cssMap API
 * const styles = cssMap({ text: { color: 'var(--ds-text)' } });
 * <Component xcss={styles.text} />
 * ```
 *
 * To concatenate and conditonally apply styles use the {@link cssMap} and {@link cx} functions.
 */ 

});
parcelRegister("6GQYv", function(module, exports) {
$parcel$export(module.exports, "createStrictAPI", function () { return $4defc20b895c71a6$export$39716b4af53f4ad; });

var $8BLWT = parcelRequire("8BLWT");

var $aU6N3 = parcelRequire("aU6N3");
function $4defc20b895c71a6$export$39716b4af53f4ad() {
    return {
        css () {
            throw (0, $8BLWT.createStrictSetupError)();
        },
        cssMap () {
            throw (0, $8BLWT.createStrictSetupError)();
        },
        cx: $aU6N3.cx,
        XCSSProp () {
            throw (0, $8BLWT.createStrictSetupError)();
        }
    };
}

});
parcelRegister("8BLWT", function(module, exports) {
$parcel$export(module.exports, "createStrictSetupError", function () { return $6446f91168c0800e$export$c4df1cb0c2b4d77c; });
const $6446f91168c0800e$export$6c9a87045746941d = ()=>{
    return new Error(`
 \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2557}   \u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2557}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}\u{255A}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{255D}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551} \u{255A}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}
 \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}

  @compiled/react

  Code was executed when it shouldn't have. This could have happened because:

  1. You haven't configured a transformer yet. Visit https://compiledcssinjs.com/docs/installation and follow the instructions.
  2. You have duplicate versions of React and hooks are blowing up. You need to de-duplicate your dependencies.

  Good luck!
`);
};
const $6446f91168c0800e$export$c4df1cb0c2b4d77c = ()=>{
    return new Error(`
 \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2557}   \u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2557}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}\u{255A}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{255D}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551} \u{255A}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}
 \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}

  @compiled/react

  Code was executed when it shouldn't have. To resolve make sure to:

  1. Set up Compiled.
  2. Configure importSources in your Compiled config to point to the module that exports the output of createStrictAPI().

  For more information visit https://compiledcssinjs.com/docs/installation and follow the instructions.
`);
};

});

parcelRegister("aU6N3", function(module, exports) {
$parcel$export(module.exports, "cx", function () { return $7f0466bce009fd76$export$a274e22fb40f762e; });

var $1uDyn = parcelRequire("1uDyn");
const $7f0466bce009fd76$export$a274e22fb40f762e = (...styles)=>{
    // At runtime TStyles is resolved down to strings, but not at compile time.
    // We circumvent the type system here because of that.
    const actualStyles = styles;
    // The output should be a union type of passed in styles. This ensures the call
    // site of xcss prop can raise violations when disallowed styles have been passed.
    return (0, $1uDyn.default)(actualStyles);
};

});
parcelRegister("1uDyn", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $1167464e46ce5272$export$2e2bcd8739ae039; });
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $1167464e46ce5272$var$ATOMIC_GROUP_LENGTH = 5;
function $1167464e46ce5272$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, $1167464e46ce5272$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}

});




parcelRegister("jmley", function(module, exports) {
$parcel$export(module.exports, "default", function () { return (parcelRequire("gfjAv")).default; });

var $gfjAv = parcelRequire("gfjAv");

});


var $3NQOU = parcelRequire("3NQOU");

var $02cSL = parcelRequire("02cSL");
(0, $3NQOU.init)((0, $02cSL.JiraSoftwareFreePage));


//# sourceMappingURL=jira-software-free-page.8830e78c.js.map
